module.exports = __webpack_public_path__ + "static/media/default-new-cover-logo.eb5699a5.svg";